import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'The Collection',
  href: '#collection'
}, {
  label: 'Inside the Guides',
  href: '#inside'
}, {
  label: 'Bonuses',
  href: '#bonuses'
}, {
  label: 'FAQs',
  href: '#faq'
}];
export function SiteNav() {
  const [open, setOpen] = useState(false);
  return <header className="relative z-30 border-b border-white/10 bg-charcoal text-ivory" data-id="element-195" data-mp="11rqd74wldbp5">
      <nav className="mx-auto flex h-[72px] max-w-site items-center justify-between px-5 md:px-8" aria-label="Primary" data-id="element-196" data-mp="16j8ghzm37oda">
        <a href="#top" className="font-display text-[15px] font-bold uppercase tracking-[0.16em]" data-id="element-197" data-mp="ssd267stkf2b">
          Diesel Fault Atlas
        </a>
        <ul className="hidden items-center gap-9 lg:flex" data-id="element-198" data-mp="xoamep77e5kd">
          {links.map(l => <li key={l.href} data-id="element-199" data-mp="itw64wf0xa9e">
              <a href={l.href} className="text-[15px] font-medium text-mist transition-colors duration-150 ease-out hover:text-ivory" data-id="element-200" data-mp="nrxsbq7qxpp3">
                {l.label}
              </a>
            </li>)}
        </ul>
        <button type="button" className="flex h-11 w-11 items-center justify-center rounded-[6px] text-ivory lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(o => !o)} data-id="element-201" data-mp="31n4q16qo1t64">
          {open ? <XIcon className="h-5 w-5" data-id="element-202" data-mp="2nvgf36s5laqq" /> : <MenuIcon className="h-5 w-5" data-id="element-203" data-mp="2nskgrhce8k1r" />}
        </button>
      </nav>
      <AnimatePresence data-id="element-204" data-mp="2ixeyqtm43piy">
        {open && <motion.ul id="mobile-nav" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-b border-white/10 bg-charcoal px-5 pb-4 lg:hidden" data-id="element-205" data-mp="2wn08dde0useb">
            {links.map(l => <li key={l.label} data-id="element-206" data-mp="34zpnufp4e86">
                <a href={l.href} onClick={() => setOpen(false)} className="block border-t border-white/10 py-3.5 text-[16px] text-ivory" data-id="element-207" data-mp="33yfrtaf1xs1">
                  {l.label}
                </a>
              </li>)}
          </motion.ul>}
      </AnimatePresence>
    </header>;
}